import React from 'react'

import LgyTooltip from 'app/components/util/lgy-tooltip/LgyTooltip'
import './lgy-section.scss'

export const LgySection = ({ header, children, className, tooltip, ...props }) =>
  <section className={`lgy-section ${className}`} {...props}>
    <span>
      <h2 aria-describedby={tooltip ? `${header}-tip` : ''}>{header}</h2>
      {tooltip && <LgyTooltip message={tooltip} id={`${header}-tip`} />}
    </span>
    <div className='lgy-section-content'>{children}</div>
  </section>

export const LgySubsection = ({ header, children, className, tooltip, ...props }) =>
  <section className={`lgy-section lgy-subsection ${className}`} {...props}>
    <span>
      <h3 aria-describedby={tooltip ? `${header}-tip` : ''}>{header}</h3>
      {tooltip && <LgyTooltip message={tooltip} id={`${header}-tip`} />}
    </span>
    <div className='lgy-subsection-content'>{children}</div>
  </section>

export const LgySubsubsection = ({ header, children, className, tooltip, ...props }) =>
  <section className={`lgy-section lgy-subsection ${className}`} {...props}>
    <span>
      <h4 aria-describedby={tooltip ? `${header}-tip` : ''}>{header}</h4>
      {tooltip && <LgyTooltip message={tooltip} id={`${header}-tip`} />}
    </span>
    <div className='lgy-subsection-content'>{children}</div>
  </section>

export default LgySection